import { render, staticRenderFns } from "./nice-datetime.vue?vue&type=template&id=81186346&scoped=true"
import script from "./nice-datetime.vue?vue&type=script&lang=js"
export * from "./nice-datetime.vue?vue&type=script&lang=js"
import style0 from "./nice-datetime.vue?vue&type=style&index=0&id=81186346&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81186346",
  null
  
)

export default component.exports